module.exports = __webpack_public_path__ + "static/media/squirrelflame-white.5bb7e500.png";